export const clearent = {
    name: 'Fast and secure payment solutions that work for your business.',
    nickName: 'Clearent',
    id: 'clearent',
    logoSvg: require('Assets/clearent_logo.png'),
    description: [ 'Grow your business faster and create a seamless payment experience with our turn-key payment integrations. Accept Payments anywhere:',
        [ 
            'In your store or in-person',
            'On your website or OnCall Air Finance+ app',
            'By email or phone',
        ]
    ],
    readMoreLink: 'http://help.creditforcomfort.com/en/articles/5952234-clearent-merchant-enrollment-integration'
}

export const porch = {
    name: '10 Year Extended Labor Warranty',
    nickName: 'Porch',
    id: 'porch',
    typeLabel: 'Business-lender',
    color: '#0',
    // TODO: make porch logo
    companyLogo: require('Assets/porch_logo.png'),
    // logoSvg: require('Assets/porch_logo.svg'),
    logoSvg: require('Assets/peac_logo.svg'),
    maxHeight: '50px',
    features: [
      'No Money Down',
      'Total project financing - equipment, install, duct work, crane rentals, warranties, etc.',
      'Building owners and non-building owners qualify',
      'No real estate blanket liens',
      'Potential tax benefits',
      '1-2 hour credit decisions'
    ],
    description: [
      "<strong>SECURE CUSTOMER LOYALTY WITH PORCH'S EXTENDED LABOR WARRANTY</strong>",
      "BENEFITS FOR YOU",
      "<strong>Customer Retention, Build Trust, and Protection</strong>",
      "Customers will turn to you for any warranty claims, ensuring repeat business for years to come. Provide comprehensive coverage to earn your customers' trust as their reliable HVAC partner. Offer your customers peace of mind by safeguarding them from unexpected expenses.",
      "BENEFITS FOR YOUR CUSTOMER",
      [
        'Simplified, digital claims process',
        'Quick turn-around',
        'Financial Security',
        'Bumper-to-bumper protection',
        'Long term coverage',
        'Total system support'
      ],
      "SIGN-UP",
      "HOW IT WORKS",
      [
        "Fill out warranty registration form for the customer",
        "Pay one-time price of $680 by credit card",
        "Get warranty registration confirmation by email",
        "Get paid $125 per hour to perform labor warranty claim",
      ]
    ],
    enrollmentLink: 'https://watsco.formstack.com/forms/lw_reseller_agreement',
    readMoreLink: 'https://help.creditforcomfort.com/en/articles/8306837-credit-for-comfort-labor-warranties?q=comfort+button'
  }

export default {
    clearent,
    porch
}
  